// ============================================================
// BILDIRIMLER
//
// Bu sayfa uygulama icindeki bildirimleri (Notification tablosu) yonetir:
// kullanicilara duyuru gonderir, gonderilmis bildirimleri listeler ve siler.
//
// ONCEKI DURUM: sayfa listelemeyi OData'dan yapiyor, ekleme/guncelleme/silmeyi
// ise kapali olan eski sunucudaki (":9093") Mega sablonu uclarina yolluyordu
// (addPopup/patchPopupMega/deletePopupMega). Ustelik form Popup_* alanlarini
// dolduruyordu; Notification tablosunda boyle alanlar yok. Yani hicbir bildirim
// eklenemiyor, hicbiri silinemiyordu. Tum islemler OData'ya alindi.
//
// NOT: telefon ekraninda cikan "push" bildirimi ayri bir servistir
// (push/push.php) ve su an sunucuda kapali. Buradan gonderilen bildirim
// kullanicinin uygulamadaki zil ikonunda gorunur.
// ============================================================
import { ODATA_BASE, PUSH_BASE, PUSH_ANAHTAR } from "helpers/api_config";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";
import TableContainer from "../../../components/Common/TableContainer";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  FormFeedback,
  UncontrolledTooltip,
  Input,
  Form,
  Spinner,
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import axios from "axios";
import { toastError, toastSuccess } from "helpers/toast";

import { Name } from "./contactlistCol";
import "./index.css";

import Breadcrumbs from "components/Common/Breadcrumb";
import SayfaRehberi from "../../../components/Common/SayfaRehberi";
import DeleteModal from "components/Common/DeleteModal";

/** Ayni anda kac istek gonderilecek (46 kullaniciya tek tek kayit atiliyor). */
const BATCH_SIZE = 6;

const formatDate = value => {
  if (!value) return "-";
  const d = new Date(value);
  if (isNaN(d.getTime())) return String(value);
  return d.toLocaleString("tr-TR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

// ---- BILDIRIM HEDEFI ----
// Notification tablosunda Notification_Entity_Type / _ID kolonlari zaten
// vardi ama panelden doldurulmuyordu; bildirime dokunan kullanici hicbir
// yere gitmiyordu. Buradaki secim mobil tarafta derin baglantiya
// cevriliyor (berlinesnaf://<tur>/<id>).
const HEDEF_TURLERI = [
  { deger: "", etiket: "Yönlendirme yok" },
  { deger: "haber", etiket: "Aktüel (haber)", tablo: "News", baslik: "News_Title" },
  { deger: "ilan", etiket: "İlan", tablo: "Job_Advertisement", baslik: "Job_Advertisement_Title" },
  { deger: "firma", etiket: "Rehber (firma)", tablo: "Company", baslik: "Company_Name" },
  { deger: "forum", etiket: "Bir Bilen (konu)", tablo: "Forum", baslik: "Forum_Title" },
  { deger: "spor", etiket: "Spor / Berlin ligleri" },
];

const ContactsList = () => {
  document.title = "Bildirimler | Berlin Esnaf Admin Paneli";

  const [notifications, setNotifications] = useState([]);
  const [userOptions, setUserOptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sending, setSending] = useState(false);

  const [modal, setModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [selected, setSelected] = useState(null);

  // "all" = tum kullanicilar, aksi halde secilen kullanicinin ID'si
  const [recipient, setRecipient] = useState("all");

  const _getNotifications = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axios.get(
        `${ODATA_BASE}/Notification?$expand=Users($select=ID,Users_Name_Surname,Users_Nickname)&$orderby=ID desc`
      );
      setNotifications((res.data && res.data.value) || []);
    } catch (e) {
      toastError("Bildirimler yüklenemedi.");
    }
    setLoading(false);
  }, []);

  const _getUsers = useCallback(async () => {
    try {
      const res = await axios.get(
        `${ODATA_BASE}/Users?$select=ID,Users_Name_Surname,Users_Nickname&$orderby=Users_Name_Surname`
      );
      setUserOptions((res.data && res.data.value) || []);
    } catch (e) {
      // alici listesi gelmezse yalnizca "tum kullanicilar" secenegi kalir
    }
  }, []);

  useEffect(() => {
    _getNotifications();
    _getUsers();
  }, [_getNotifications, _getUsers]);


  const [hedefTuru, setHedefTuru] = useState("");
  const [hedefID, setHedefID] = useState("");
  const [hedefSecenekleri, setHedefSecenekleri] = useState([]);
  const [hedefYukleniyor, setHedefYukleniyor] = useState(false);

  // Tur secilince o tablodaki son kayitlar listeleniyor.
  useEffect(() => {
    const tur = HEDEF_TURLERI.find(t => t.deger === hedefTuru);
    setHedefID("");
    if (!tur || !tur.tablo) {
      setHedefSecenekleri([]);
      return;
    }
    let iptal = false;
    setHedefYukleniyor(true);
    axios
      .get(`${ODATA_BASE}/${tur.tablo}`, {
        params: { "$select": `ID,${tur.baslik}`, "$orderby": "ID desc", "$top": 200 },
      })
      .then(res => {
        if (iptal) return;
        const liste = (res.data && res.data.value) || [];
        setHedefSecenekleri(
          liste.map(k => ({
            ID: k.ID,
            // Baslik alanlari HTML icerebiliyor (CKEditor); listede duz metin gosteriyoruz.
            etiket: String(k[tur.baslik] || `#${k.ID}`)
              .replace(/<[^>]*>/g, " ")
              .replace(/\s+/g, " ")
              .trim()
              .slice(0, 90) || `#${k.ID}`,
          }))
        );
      })
      .catch(() => { if (!iptal) setHedefSecenekleri([]); })
      .finally(() => { if (!iptal) setHedefYukleniyor(false); });
    return () => { iptal = true; };
    // NOT: Burada bir zamanlar react-hooks bagimlilik kuralini susturan
    // bir yorum satiri vardi. CRA'nin derleyicisi react-hooks eklentisini
    // hic yuklemiyor (eslint-config-react-app/base "root: true" ile
    // eslintrc zincirini kestigi icin package.json icindeki eslintConfig
    // hic okunmuyor), dolayisiyla o kural zaten aktif degildi. Tanimsiz
    // bir kurali susturmaya calismak ESLint'e "rule was not found" hatasi
    // verdiriyor ve PANELIN TUM DERLEMESINI durduruyordu.
    // Kural calismadigi icin satirin kaldirilmasi davranisi degistirmez.
    // Bagimlilik listesi bilerek yalniz [hedefTuru]: efekt sadece tur
    // degisince yeniden calismali.
  }, [hedefTuru]);

  const toggle = () => setModal(m => !m);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: { title: "", message: "" },
    validationSchema: Yup.object({
      title: Yup.string().trim().required("Lütfen başlık giriniz").max(150, "En fazla 150 karakter"),
      message: Yup.string().trim().required("Lütfen mesaj giriniz").max(500, "En fazla 500 karakter"),
    }),
    onSubmit: async values => {
      const targets =
        recipient === "all"
          ? userOptions.map(u => u.ID)
          : [parseInt(recipient, 10)];

      if (targets.length === 0) {
        toastError("Gönderilecek kullanıcı bulunamadı.");
        return;
      }

      setSending(true);
      const createdAt = new Date().toISOString();
      let ok = 0;
      let failed = 0;

      for (let i = 0; i < targets.length; i += BATCH_SIZE) {
        const batch = targets.slice(i, i + BATCH_SIZE);
        // eslint-disable-next-line no-await-in-loop
        const results = await Promise.all(
          batch.map(userId =>
            axios
              .post(`${ODATA_BASE}/Notification`, {
                Users_ID: userId,
                Notification_Title: values.title.trim(),
                Notification_Desc: values.message.trim(),
                Created_DateTime: createdAt,
                Notification_Seen: false,
                // Bos birakilirsa bildirim yonlendirmesiz kalir.
                Notification_Entity_Type: hedefTuru || null,
                Notification_Entity_ID: hedefID ? parseInt(hedefID, 10) : null,
              })
              .then(() => true)
              .catch(() => false)
          )
        );
        results.forEach(r => (r ? (ok += 1) : (failed += 1)));
      }

      // ---- PUSH BILDIRIMI ----
      // Yukaridaki dongu Notification tablosuna satir yaziyor; o satir
      // yalnizca uygulamadaki ZIL IKONUNDA gorunuyor. Telefon ekraninda
      // bildirimin belirmesi icin ayrica backend'in /api/push ucu
      // cagriliyor. Uc yoksa/erisilemezse bildirim yine kaydedilmis
      // olur; kullaniciya durum ayrica bildiriliyor.
      let pushDurumu = "atlandi";
      if (ok > 0 && PUSH_ANAHTAR) {
        try {
          const govde = {
            Baslik: values.title.trim(),
            Mesaj: values.message.trim(),
            HedefTuru: hedefTuru || null,
            HedefId: hedefID || null,
          };
          const adres = recipient === "all"
            ? `${PUSH_BASE}/konu`
            : `${PUSH_BASE}/kullanici`;
          // Herkese gonderimde "all" konusu; tek kisiye gonderimde
          // kullanicinin kendi konusu (uygulamada user<ID>'ye abone oluyor).
          const yuk = recipient === "all"
            ? { ...govde, Konu: "all" }
            : { ...govde, KullaniciId: parseInt(recipient, 10) };

          await axios.post(adres, yuk, {
            headers: { "X-Push-Anahtar": PUSH_ANAHTAR },
          });
          pushDurumu = "gonderildi";
        } catch (e) {
          pushDurumu = "hata";
        }
      }

      setSending(false);
      toggle();
      validation.resetForm();
      setRecipient("all");
      setHedefTuru("");
      setHedefID("");

      // Push'un gidip gitmedigi ayri bir bilgi: kayit basarili olup
      // push basarisiz olabilir, kullanici bunu bilmeli.
      const pushNotu =
        pushDurumu === "gonderildi" ? " Telefon bildirimi de gönderildi."
        : pushDurumu === "hata" ? " Ancak telefon bildirimi gönderilemedi (yalnızca uygulama içi zilde görünür)."
        : "";

      if (ok > 0 && failed === 0) {
        if (pushDurumu === "hata") toastError(`Bildirim ${ok} kullanıcıya kaydedildi.${pushNotu}`);
        else toastSuccess(`Bildirim ${ok} kullanıcıya gönderildi.${pushNotu}`);
      } else if (ok > 0) {
        toastError(`${ok} kullanıcıya gönderildi, ${failed} kullanıcıda hata oluştu.${pushNotu}`);
      } else {
        toastError("Bildirim gönderilemedi. Lütfen tekrar deneyin.");
      }

      _getNotifications();
    },
  });

  const onClickDelete = row => {
    setSelected(row);
    setDeleteModal(true);
  };

  const handleDelete = async () => {
    if (!selected || !selected.ID) {
      setDeleteModal(false);
      return;
    }
    try {
      await axios.delete(`${ODATA_BASE}/Notification(${selected.ID})`);
      toastSuccess("Bildirim silindi.");
      setNotifications(list => list.filter(n => n.ID !== selected.ID));
    } catch (e) {
      toastError("Bildirim silinemedi. Lütfen tekrar deneyin.");
    }
    setSelected(null);
    setDeleteModal(false);
  };

  const node = useRef();

  const columns = useMemo(
    () => [
      {
        Header: "Başlık",
        accessor: "Notification_Title",
        filterable: true,
        Cell: cellProps => <Name {...cellProps} />,
      },
      {
        Header: "Mesaj",
        accessor: "Notification_Desc",
        filterable: true,
        Cell: cellProps => <Name {...cellProps} />,
      },
      {
        Header: "Alıcı",
        filterable: true,
        accessor: row =>
          (row.Users && (row.Users.Users_Name_Surname || row.Users.Users_Nickname)) ||
          (row.Users_ID ? `#${row.Users_ID}` : "-"),
      },
      {
        // Bildirime dokunulunca acilacak icerik; bos ise yonlendirme yok.
        Header: "Yönlendirme",
        accessor: row => {
          if (!row.Notification_Entity_Type) return "Yönlendirme yok";
          const tur = HEDEF_TURLERI.find(t => t.deger === row.Notification_Entity_Type);
          const ad = (tur && tur.etiket) || row.Notification_Entity_Type;
          return row.Notification_Entity_ID ? `${ad} #${row.Notification_Entity_ID}` : ad;
        },
      },
      {
        Header: "Tarih",
        accessor: row => formatDate(row.Created_DateTime),
        disableFilters: true,
      },
      {
        Header: "Durum",
        disableFilters: true,
        accessor: row => (row.Notification_Seen ? "Okundu" : "Okunmadı"),
        Cell: cellProps => (
          <span
            className={
              cellProps.value === "Okundu"
                ? "badge bg-success-subtle text-success"
                : "badge bg-warning-subtle text-warning"
            }
          >
            {cellProps.value}
          </span>
        ),
      },
      {
        Header: "İşlemler",
        disableFilters: true,
        Cell: cellProps => (
          <div className="d-flex gap-3">
            <Link
              to="#"
              className="text-danger"
              onClick={() => onClickDelete(cellProps.row.original)}
            >
              <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
              <UncontrolledTooltip placement="top" target="deletetooltip">
                Sil
              </UncontrolledTooltip>
            </Link>
          </div>
        ),
      },
    ],
    []
  );

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDelete}
        onCloseClick={() => setDeleteModal(false)}
      />
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Yönetim" breadcrumbItem="Bildirimler" />
          <SayfaRehberi sayfa="bildirimler" />

          <div className="alert alert-info py-2 font-size-13">
            <i className="bx bx-info-circle align-middle me-1" />
            Buradan gönderilen bildirim, kullanıcının uygulamadaki <strong>zil ikonunda</strong>{" "}
            görünür. Telefon ekranında beliren anlık (push) bildirim ayrı bir servistir ve şu an
            kapalıdır.
          </div>

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  {loading ? (
                    <div className="text-center py-5">
                      <Spinner color="primary" />
                    </div>
                  ) : (
                    <TableContainer
                      columns={columns}
                      data={notifications}
                      ref={node}
                      isGlobalFilter={true}
                      isPopupList={true}
                      handleUserClick={() => {
                        validation.resetForm();
                        setRecipient("all");
                        toggle();
                      }}
                      customPageSize={10}
                      className="custom-header-css"
                    />
                  )}

                  <Modal isOpen={modal} toggle={toggle}>
                    <ModalHeader toggle={toggle} tag="h4">
                      Bildirim Gönder
                    </ModalHeader>
                    <ModalBody>
                      <Form
                        onSubmit={e => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}
                      >
                        <div className="mb-3">
                          <Label className="form-label">Alıcı</Label>
                          <Input
                            type="select"
                            className="form-select"
                            value={recipient}
                            onChange={e => setRecipient(e.target.value)}
                          >
                            <option value="all">
                              Tüm kullanıcılar ({userOptions.length} kişi)
                            </option>
                            {userOptions.map(u => (
                              <option value={u.ID} key={u.ID}>
                                {u.Users_Name_Surname || u.Users_Nickname || `#${u.ID}`}
                              </option>
                            ))}
                          </Input>
                        </div>

                        <div className="mb-3">
                          <Label className="form-label">Başlık</Label>
                          <Input
                            name="title"
                            type="text"
                            placeholder="Örn: Yeni özellik yayında"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.title || ""}
                            invalid={!!(validation.touched.title && validation.errors.title)}
                          />
                          {validation.touched.title && validation.errors.title ? (
                            <FormFeedback type="invalid">{validation.errors.title}</FormFeedback>
                          ) : null}
                        </div>

                        <div className="mb-3">
                          <Label className="form-label">Mesaj</Label>
                          <Input
                            name="message"
                            type="textarea"
                            rows="4"
                            placeholder="Kullanıcılara iletilecek mesaj"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.message || ""}
                            invalid={!!(validation.touched.message && validation.errors.message)}
                          />
                          {validation.touched.message && validation.errors.message ? (
                            <FormFeedback type="invalid">{validation.errors.message}</FormFeedback>
                          ) : null}
                        </div>

                        {/* Bildirime dokunulunca acilacak icerik.
                            Bos birakilirsa bildirim sadece listede gorunur. */}
                        <div className="mb-3">
                          <Label className="form-label">Yönlendirme (isteğe bağlı)</Label>
                          <Input
                            type="select"
                            className="form-select"
                            value={hedefTuru}
                            onChange={e => setHedefTuru(e.target.value)}
                          >
                            {HEDEF_TURLERI.map(t => (
                              <option value={t.deger} key={t.deger || "yok"}>
                                {t.etiket}
                              </option>
                            ))}
                          </Input>
                          <small className="text-muted">
                            Seçilen içerik, kullanıcı bildirime dokunduğunda uygulamada açılır.
                          </small>
                        </div>

                        {hedefTuru && hedefTuru !== "spor" ? (
                          <div className="mb-3">
                            <Label className="form-label">Hangi kayıt?</Label>
                            <Input
                              type="select"
                              className="form-select"
                              value={hedefID}
                              onChange={e => setHedefID(e.target.value)}
                              disabled={hedefYukleniyor}
                            >
                              <option value="">
                                {hedefYukleniyor ? "Yükleniyor..." : "Seçiniz"}
                              </option>
                              {hedefSecenekleri.map(k => (
                                <option value={k.ID} key={k.ID}>
                                  #{k.ID} — {k.etiket}
                                </option>
                              ))}
                            </Input>
                            {!hedefYukleniyor && hedefSecenekleri.length === 0 ? (
                              <small className="text-danger">Kayıt bulunamadı.</small>
                            ) : null}
                          </div>
                        ) : null}

                        <Row>
                          <Col>
                            <div className="text-end">
                              <button
                                type="submit"
                                className="btn btn-success save-user"
                                disabled={sending || (!!hedefTuru && hedefTuru !== "spor" && !hedefID)}
                              >
                                {sending ? "Gönderiliyor..." : "Gönder"}
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </ModalBody>
                  </Modal>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(ContactsList);
